export type OpeningStatus = 'open' | 'on_hold' | 'closed' | 'filled';
export type CandidateStatus =
  | 'new'
  | 'screening'
  | 'interviewing'
  | 'offer'
  | 'hired'
  | 'rejected';
export type InterviewOutcome = 'pending' | 'passed' | 'failed';
export type OfferStatus = 'draft' | 'sent' | 'accepted' | 'declined';

export const OPENING_STATUSES: { value: OpeningStatus; label: string }[] = [
  { value: 'open', label: 'Open' },
  { value: 'on_hold', label: 'On hold' },
  { value: 'closed', label: 'Closed' },
  { value: 'filled', label: 'Filled' },
];

export const CANDIDATE_STATUSES: { value: CandidateStatus; label: string }[] = [
  { value: 'new', label: 'New' },
  { value: 'screening', label: 'Screening' },
  { value: 'interviewing', label: 'Interviewing' },
  { value: 'offer', label: 'Offer' },
  { value: 'hired', label: 'Hired' },
  { value: 'rejected', label: 'Rejected' },
];

export const INTERVIEW_OUTCOMES: { value: InterviewOutcome; label: string }[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
];

export const OFFER_STATUSES: { value: OfferStatus; label: string }[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'declined', label: 'Declined' },
];

export const CANDIDATE_STATUS_LABEL: Record<CandidateStatus, string> = Object.fromEntries(
  CANDIDATE_STATUSES.map((s) => [s.value, s.label]),
) as Record<CandidateStatus, string>;

export const OPENING_STATUS_LABEL: Record<OpeningStatus, string> = Object.fromEntries(
  OPENING_STATUSES.map((s) => [s.value, s.label]),
) as Record<OpeningStatus, string>;

export const OFFER_STATUS_LABEL: Record<OfferStatus, string> = Object.fromEntries(
  OFFER_STATUSES.map((s) => [s.value, s.label]),
) as Record<OfferStatus, string>;

export const INTERVIEW_OUTCOME_LABEL: Record<InterviewOutcome, string> = Object.fromEntries(
  INTERVIEW_OUTCOMES.map((s) => [s.value, s.label]),
) as Record<InterviewOutcome, string>;

/** Default interview stages for an IT/software company. `stage_name` is free
 *  text on the backend, so these seed a quick-pick — any value still works. */
export const INTERVIEW_STAGES = [
  'Recruiter screen',
  'Hiring manager screen',
  'Technical screen',
  'Live coding',
  'Take-home assignment',
  'System design',
  'Technical deep dive',
  'Team / culture fit',
  'On-site / Final round',
  'Founder / Executive interview',
] as const;

/** Common scorecard criteria, each rated 1–5 by the interviewer. */
export const INTERVIEW_CRITERIA = [
  'English level',
  'Problem solving',
  'Soft skills',
  'Communication',
  'Hard skills',
  'Architecture',
  'Patterns',
  'Code quality',
] as const;
